module.exports = __webpack_public_path__ + "static/media/img_linea_gris_desktop.304905e9.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/img_linea_gris_desktop.webp
// module id = 168
// module chunks = 1